module.exports = __webpack_public_path__ + "dimer/static/img/tempHeadImg.df9bc62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tempHeadImg.jpg
// module id = 6aeF
// module chunks = 0